/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { serverBaseURL } from "common/settings";

function DeleteAccount() {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);
  const [loadingOpen, setLoadingOpen] = useState(false);
  const handleLoadingClose = () => setLoadingOpen(false);
  const handleLoadingOpen = () => setLoadingOpen(true);
  const { getToken } = useKindeAuth();
  async function deleteAccount() {
    const accessToken = await getToken();
    handleLoadingOpen();
    const deleteAccount = await (
      await fetch(`${serverBaseURL}delete_account`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
    ).json();
    handleLoadingClose();
    console.log(deleteAccount);
  }
  return (
    <Card id="delete-account">
      <MDBox
        pr={3}
        display="flex"
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        flexDirection={{ xs: "column", sm: "row" }}
      >
        <Backdrop
          sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
          open={loadingOpen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Modal
          open={confirmOpen}
          onClick={handleConfirmClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <MDBox
            p={5}
            position="absolute"
            color="white"
            bgColor="white"
            transform="translate(-50%, -50%)"
          >
            <MDTypography variant="h5">
              Would you like to delete your account? If you proceed, a deletion notice will be sent
              by our support team within five business days.
            </MDTypography>
            <br />
            <Stack spacing={5} direction="row">
              <MDButton
                p={5}
                variant="gradient"
                color="dark"
                onClick={() => {
                  deleteAccount();
                  handleConfirmClose();
                }}
              >
                Delete Account
              </MDButton>
              <MDButton
                p={5}
                variant="gradient"
                color="dark"
                onClick={() => {
                  handleConfirmClose();
                }}
              >
                Cancel
              </MDButton>
            </Stack>
          </MDBox>
        </Modal>
        <MDBox p={3} lineHeight={1}>
          <MDBox mb={1}>
            <MDTypography variant="h5">Delete Account</MDTypography>
          </MDBox>
          <MDTypography variant="button" color="text">
            After you confirm the account deletion, we will receive your account deletion request.
            Our operations team will then verify the request and delete your account accordingly.
          </MDTypography>
          <br />
          <MDBox ml="auto">
            <MDButton
              variant="gradient"
              color="error"
              size="small"
              onClick={() => handleConfirmOpen()}
            >
              Delete Account
            </MDButton>
          </MDBox>
        </MDBox>
        {/*}
        <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
          <MDButton variant="outlined" color="secondary">
            deactivate
          </MDButton>
          <MDBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
            <MDButton variant="gradient" color="error" sx={{ height: "100%" }}>
              delete account
            </MDButton>
          </MDBox>
        </MDBox>
        {*/}
      </MDBox>
    </Card>
  );
}

export default DeleteAccount;
